import { render, staticRenderFns } from "./storeDecoration.vue?vue&type=template&id=48c6f945&scoped=true&"
import script from "./storeDecoration.vue?vue&type=script&lang=js&"
export * from "./storeDecoration.vue?vue&type=script&lang=js&"
import style0 from "./storeDecoration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./storeDecoration.vue?vue&type=style&index=1&id=48c6f945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6f945",
  null
  
)

component.options.__file = "storeDecoration.vue"
export default component.exports